<template>
<div class="content">
  <div class="box-list">
    <div class="item" @click="goDes(item.id)" v-for="(item,index) in list" :key="index">{{item.title}}</div>
  </div>
</div>
</template>

<script>
import { articleList } from '@/api/xieyi'
export default {
  name: "xieYiList",
  data(){
    return {
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      var that = this
      var data = {
        type: ' agreement'
      }
      articleList(data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          that.list = res.data.data

        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    goDes(id){
      console.log(id)
      this.$router.push({path:'/xieYiDes',query: {id:id}})
    }
  }
}
</script>

<style lang="scss" scoped>
.box-list{
  .item{
    background: #FFFFFF;padding: 35px 24px;margin-top: 24px;font-size: 30px;
  }
}
</style>
